import { Accordion, styled } from "@mui/material";

export const AccordionWrapper = styled(Accordion)`
    border-radius: 12px !important;
    box-shadow: none;
    padding: 4px 0;

    .Mui-expanded .MuiAccordionSummary-expandIconWrapper {
        background-color: rgba(8,126,56,0.2);
        border-radius: 8px;
    }

    .MuiAccordionSummary-expandIconWrapper {
        svg {
            fill: rgba(8,126,56);
        }
    }
`;
